import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "convex/react";
import { api } from "../../../../convex/_generated/api";
import { t } from "../../i18n";

const SLIDES = [
  {
    emoji: "🔔",
    titleKey: "previewFeature4",
    description: "Get instant alerts when someone follows or unfollows. Never miss a change.",
  },
  {
    emoji: "📊",
    titleKey: "previewFeature5",
    description: "See who they follow broken down by gender. Know your data at a glance.",
  },
  {
    emoji: "🔒",
    titleKey: "paywallFeaturePrivateTitle",
    description: "No Instagram login required. 100% anonymous. They'll never know you're tracking.",
  },
];

export function OnboardingPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const registerWithConsent = useMutation(api.onboarding.registerWithConsent);

  const handleNext = () => {
    if (step < SLIDES.length - 1) {
      setStep((s) => s + 1);
    } else {
      // Register consent then proceed
      registerWithConsent({
        termsVersion: "1.0",
        policyVersion: "1.0",
        deviceInfo: navigator.userAgent,
      })
        .then(() => navigate("/onboarding/how-you-heard"))
        .catch(() => navigate("/onboarding/how-you-heard"));
    }
  };

  const slide = SLIDES[step];

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #fdf2f2 0%, #ffffff 100%)",
        padding: "24px",
        textAlign: "center",
      }}
    >
      {/* Progress dots */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "48px" }}>
        {SLIDES.map((_, i) => (
          <div
            key={i}
            style={{
              width: i === step ? "24px" : "8px",
              height: "8px",
              borderRadius: "4px",
              background: i === step ? "var(--pink-primary, #ff6b8a)" : "#d1d5db",
              transition: "all 0.3s ease",
            }}
          />
        ))}
      </div>

      {/* Slide content */}
      <div
        style={{
          fontSize: "64px",
          marginBottom: "24px",
          animation: "fadeInUp 0.4s ease",
        }}
      >
        {slide.emoji}
      </div>

      <h1
        style={{
          fontSize: "1.75rem",
          fontWeight: 800,
          color: "#171717",
          marginBottom: "12px",
          maxWidth: "320px",
          animation: "fadeInUp 0.4s ease 0.1s both",
        }}
      >
        {t(slide.titleKey)}
      </h1>

      <p
        style={{
          fontSize: "1rem",
          color: "#737373",
          maxWidth: "300px",
          lineHeight: 1.6,
          animation: "fadeInUp 0.4s ease 0.2s both",
        }}
      >
        {slide.description}
      </p>

      {/* CTA */}
      <button
        onClick={handleNext}
        style={{
          marginTop: "48px",
          background: "var(--pink-primary, #ff6b8a)",
          color: "white",
          border: "none",
          padding: "14px 48px",
          borderRadius: "16px",
          fontWeight: 700,
          fontSize: "1.0625rem",
          cursor: "pointer",
          boxShadow: "0 4px 16px rgba(255, 107, 138, 0.3)",
        }}
      >
        {step < SLIDES.length - 1 ? "Next" : "Get Started"}
      </button>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
